/* @flow */

import React from 'react';

import InformationPage from './InformationPage';

const ZkaiPrivacy = () => (
  <InformationPage
    subtitle={
      <React.Fragment>
        ※13さいになっていない
        <ruby>
          場<rt>ば</rt>合<rt>あい</rt>
        </ruby>
        は、おうちの
        <ruby>
          人<rt>ひと</rt>
        </ruby>
        に
        <ruby>
          読<rt>よ</rt>
        </ruby>
        んでもらってください。
      </React.Fragment>
    }
    hasCloseButton={true}
    title="プライバシーポリシー"
  >
    <p>
      このプライバシーポリシー（以下「本プライバシーポリシー」といいます）は、株式会社Z会のプログラミング学習「Z-pro」をとおして、株式会社ソニー・グローバルエデュケーション（以下「SGED」といいます）が提供する、体験型プログラミング教育サービス（以下、「本サービス」といいます）を利用されるお客様（以下「お客様」または「ユーザー」といいます）に適用されます。
    </p>
    <p>
      本プライバシーポリシーでは、本サービスに関してSGEDが収集する情報の利用および保存の方法、並びにお客様が本サービスに関しSGEDにコンタクトされたい場合の方法について記載しています。本サービスには、追加的なポリシーが適用される場合がありますので、その場合は追加で適用されるポリシーも併せてお読みいただき、同意の上ご利用ください。
    </p>
    <p>
      SGEDは、お客様からお預かりする個人情報を大切な資産であると認識し、お客様により良いサービスをご提供するにあたり、個人情報を適切に管理し、お客様のご希望に沿って利用することを、重要な責務であると考えています。個人情報の保護に万全を尽くすため、SGEDは、ソニーグループの一員として、ソニーグループ・プライバシーポリシーを遵守いたします。本プライバシーポリシーは、ソニーグループ・プライバシーポリシーに追加して適用されます。ソニーグループ・プライバシーポリシーにつきましては下記をご覧ください。
      <br />
      <a target="_blank" rel="noopener noreferrer" className="proc-link" href="https://www.sonyged.com/ja/privacy">
        https://www.sonyged.com/ja/privacy
      </a>
    </p>
    <h3>1. 情報の収集</h3>
    <p>
      SGEDは、ユーザー（登録されたお子様等を含みます。）が本サービスをご利用の際、以下のような情報を提供していただく、もしくは自動的に受領する場合があります。
    </p>
    <ol>
      <li>① 個人を特定するためのものではなく、他のユーザーと区別するためにのみ用いられる情報</li>
      <li>② 本サービスのご利用履歴（例：アバター選択、コース選択、学習の進捗状況、結果等）</li>
      <li>③ アプリの実行環境（例：ブラウザのバージョン、デバイス情報、IPアドレス等）</li>
    </ol>
    <h3>2.情報の利用目的</h3>
    <p>
      SGEDは、本サービスを通じて収集された情報を、個人を特定できない形で集計・統計化し、各種サービスや製品の改良、新サービスや新製品の開発、その他SGEDの事業活動のために利用いたします。
    </p>
    <h3>3. 情報の共有および開示</h3>
    <h4>(1) 第三者への開示</h4>
    <p>SGEDにユーザーが送信しまたはSGEDが収集し保存される情報は、下記の場合、第三者に開示されることがあります。</p>
    <ol>
      <li>
        ①
        第2条に記載した利用目的で、ソニーグループ会社（ソニーマーケティング株式会社、ソニーグループ株式会社およびソニーグループ株式会社が直接または間接に発行済議決権付株式または持分の過半数を保有する会社）と共同で利用させていただく場合（かかる場合、個人データの管理について責任を有する者は
        <a target="_blank" rel="noopener noreferrer" href="https://www.sonyged.com/ja/about/">
          SGED
        </a>
        となります）ならびに外部の事業者に対して、一定の情報を提供する場合。
      </li>
      <li>② SGEDが第4条に従い業務を外部に委託し、当該業務委託先が情報を取り扱う場合。</li>
      <li>
        ③
        SGEDが事業の全部または一部を別会社に売却もしくは移転することにより、当該取引の一部として当該売却先もしくは移転先に情報を譲渡する場合。
      </li>
    </ol>
    <h4>(2) 法令等に基づく開示</h4>
    <p>
      SGEDは、ユーザー自らまたはユーザーに対して調査の要請があった場合、または違法行為、犯罪その他の有害とみなされる行為に対してSGED自身または第三者の利益を保護する必要がある場合、法令による要請、警察その他行政機関からの命令に従って、情報を第三者に開示する場合があります。
    </p>
    <h3>4. 情報の保持および管理</h3>
    <h4>(1) 情報の保持</h4>
    <p>
      SGEDは、第1条に記載する情報を、ユーザーが本サービスをご利用になる期間中、およびそれ以降第2条の利用目的を達成するために必要な期間保持いたします。
    </p>
    <h4>(2) 業務委託</h4>
    <p>
      SGEDは、本サービスの提供、運営等に関して、一部の業務を国内および米国の業務委託先に委託する場合があります。かかる業務委託先には、IT
      サービスプロバイダやデータホスティングプロバイダが含まれます。なお、当該国の個人情報保護に関する法制度の概要は
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/#gaikoku"
      >
        こちら
      </a>
      からご確認ください。
    </p>
    <h4>(3) 安全管理</h4>
    <p>
      SGEDでは、国際標準化機構 (ISO) の 27001 規格群や米国国立標準技術研究所 (NIST)
      のSP800シリーズなどの業界標準やベストプラクティスに基づき定められたソニーグループ共通のポリシーを適用し、SGEDが取得・保有する個人情報に対して厳重なセキュリティ対策を講じています。この対策には、組織的な情報セキュリティマネジメントの実施や定期的な見直し、従業員に対する定期的な教育研修、定期的な情報資産の棚卸、物理的な安全管理措置の実施（従業員の入退室管理、端末管理等）、通信の暗号化、厳格なアクセス制御、情報システムに対する定期的な脆弱性管理、などが含まれます。また、SGEDでは、各種情報の一部を米国にあるデータホスティングプロバイダに保存することがあります（上記
      4(2)「業務委託」参照）。この場合、SGEDは、同プロバイダにおいて情報の安全管理のために必要かつ適切な措置が行われていることを確認の上、上記保存を行います。なお、SGEDは、
      <a target="_blank" rel="noopener noreferrer" href="https://www.sonyged.com/ja/privacy-policy/">
        国内ソニーグループ・共通プライバシーポリシー
      </a>
      においても個人情報の取り扱いに関する基本方針を表明しています。安全管理措置の概要については同ポリシーもご参照ください。
    </p>
    <h3>5. クッキー等の使用</h3>
    <p>
      SGEDは、本サービスに関連して、以下のような技術を用いて、利用情報（装置識別名を含む）の収集を行う場合があります。
    </p>
    <ol>
      <li>
        ①
        クッキー：「クッキー」（htmlファイル、Flashファイル、またはその他技術を含む）は、ユーザーの嗜好や活動の記録に役立つ小さいテキストファイルです。クッキーは、ユーザーが本サービスにアクセスする際、デバイス上に保存されます。クッキーはユーザーやユーザーの嗜好の記憶、本サービスへのアクセス状況の追跡、ユーザーの本サービス上での体験のカスタマイズなど、様々な目的で使用されることがあります。ユーザーはご自身のインターネットブラウザの設定を変更することで、クッキーの受け入れを拒否することができます。デバイス上でクッキーを無効にした場合、本サービスが適切に機能しない場合があります。
      </li>
      <li>
        ②
        ウェブ・ビーコン：「ウェブ・ビーコン」（画像タグ、ピクセルタグ、GIFまたはウェブ・バグとしても知られています）は、ページ閲覧数、販促宣伝の閲覧、広告に対する反応といった広告に関するデータを収集するために用いられる小さなコードです。ウェブ・ビーコンやそれに類似する技術は、本サービスの利用者のカウントまたはユーザーの閲覧動向の監視といった（ただしこれに限定されません）様々な目的で使用される場合があります。
      </li>
    </ol>
    <h3>6. 情報に関する請求等</h3>
    <p>
      ユーザーが、SGEDによる情報の利用目的の確認、訂正、利用の停止または消去、第三者への提供の停止その他の対応を希望される場合には、第8条に記載の連絡先までご連絡ください。SGEDは、合理的な時間および方法にて対応いたします。なお、情報の一部もしくは全ては、本サービスの機能を適切に提供するために必要であり、SGEDは、法令により当該情報の一部を保持する場合があることをご了解ください。
    </p>
    <h3>7. 本プライバシーポリシーの変更</h3>
    <p>
      SGEDは、法令で認められた範囲において、本プライバシーポリシーを随時変更することができます。SGEDは修正後のプライバシーポリシーを、本サービス内または本サービスに関する説明ウェブサイトページに掲載しますので、ユーザーは、プライバシーポリシーの変更について定期的にご確認ください。
    </p>
    <h3>8. 問い合わせ窓口</h3>
    <p>本プライバシーポリシーについてご質問等がある場合は、下記のいずれかの方法によりSGEDまでご連絡ください。</p>
    <ul />
    <div className={'gray-container'}>
      <ul>
        <li>
          <a
            className="proc-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://support.sonyged.com/hc/ja/requests/new"
          >
            オンラインフォーム
          </a>
        </li>
        <li>郵送：〒141-0031 東京都品川区西五反田 2-11-17</li>
        <li>株式会社ソニー・グローバルエデュケーション</li>
      </ul>
    </div>
    <div className="notice">Last Updated: 2022/06/06</div>
    <p>
      旧版は
      <a target="_blank" href="/z-pro-privacy-old">
        こちら
      </a>
    </p>
  </InformationPage>
);

export default ZkaiPrivacy;
